import { useEffect, useState } from "react";
import "./SharePopup.css";
import { useSelector } from "react-redux";
import { MdOutlineFileUpload } from "react-icons/md";

const SharePopup = ({ productId, refCode }) => {
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    // console.log(userInfo);
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         getInfoUserActive();
    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, []);

    // const getInfoUserActive = async () => {
    //     // console.log(window.localStorage.getItem('userInfoActive'));
    //     if (!window.localStorage.getItem('userInfoActive')) {
    //         return
    //     }
    //     let data = JSON.parse(window.localStorage.getItem('userInfoActive'));
    //     console.log(data);
    //     // setDataU(data)
    // };

    const [show, setShow] = useState(false);
    const [copied, setCopied] = useState(false);
    const shareUrl = `${window.location.origin}/products/${productId}?ref=${userInfo?.name}`;

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <>
           <button className="mt-4     text-base hover:text-[--color-button-3] flex items-center gap-4"  onClick={() => setShow(true)}><MdOutlineFileUpload className="text-xl" /> Chia sẻ </button>
            {show && (
                <div className="popup-overlay">
                    <div className="popup">
                        <h3>Chia sẻ sản phẩm</h3>
                        <input value={shareUrl} readOnly className="share-input" />
                        <button className="copy-btn" onClick={copyToClipboard}>
                            {copied ? "✅ Đã copy!" : "📋 Copy link"}
                        </button>
                        <div className="social-btns">
                            <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                                target="_blank" rel="noopener noreferrer" className="fb">
                                👍 Facebook
                            </a>
                            <a href={`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}`}
                                target="_blank" rel="noopener noreferrer" className="tg">
                                ✈️ Telegram
                            </a>
                            <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`}
                                target="_blank" rel="noopener noreferrer" className="tw">
                                🐦 Twitter
                            </a>
                        </div>
                        <button className="close-btn" onClick={() => setShow(false)}>Đóng</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default SharePopup;
